/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=32895d16&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=32895d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32895d16",
  null
  
)

export default component.exports